import React, { useEffect, useContext, useState } from "react";
import seanPhoto from "../../assets/images/sean.png";
import * as elementUtils from "../../utils/elementUtils";
import ThemeContext from "../../context/ThemeContext";
import "./header.css";

import linkedinDark from "../../assets/images/linkedin_light.png";
import linkedinLight from "../../assets/images/linkedin_dark.png";
import githubLight from "../../assets/images/github_light.png";
import githubDark from "../../assets/images/github_dark.png";
import resumeIcon from "../../assets/images/resume_icon.svg";
import ContactMe from "../contactMe/contact-me.jsx";
import { LogEvent } from "../../utils/EventLogging.js";

function Header(props) {
  const { theme } = useContext(ThemeContext);
  const [showContactMe, setShowContactMe] = useState(false);

  useEffect(() => {
    const handleOpenContact = () => setShowContactMe(true);
    window.addEventListener('openContactForm', handleOpenContact);

    setTimeout(() => {
      setNavHome();
    }, 100);

    return () => window.removeEventListener('openContactForm', handleOpenContact);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setAllInactive() {
    document.querySelectorAll("a.active").forEach((link) => {
      link.classList.remove("active");
    });
  }

  function setNavHome() {
    let header = document.querySelector("#header");
    elementUtils.onNodeVisible(
      header,
      () => {
        setAllInactive();
        document.querySelector("#header-link")?.classList.add("active");
        document.querySelector("#header-link-mobile")?.classList.add("active");
      },
      window.innerWidth > 750 ? 0.4 : 0.1
    );
  }

  function Linkedin() {
    LogEvent("Linkedin");
    window.open(window.location.origin + "/linkedin", "_blank");
  }

  function Github() {
    LogEvent("GitHub");
    window.open(window.location.origin + "/github", "_blank");
  }

  function Resume() {
    LogEvent("Resume");
    window.location.href = window.location.origin + "/resume";
  }

  return (
    <section id="header" className="hero-section">
      <div className="hero-content">
        <div className="hero-text-container fade-in-up">
          <h1 className="hero-title">Sean Brill</h1>
          <h2 className="hero-subtitle">Software Engineer <span className="highlight-text">& Consultant</span></h2>
          <p className="hero-bio">
            Experienced Full Stack Engineer with a degree in Information Sciences and Technology from Penn State.
            I build performant, scalable web applications and offer specialized consulting to bring your complex technical visions to life.
          </p>

          <div className="hero-cta-group">
            <button
              onClick={() => setShowContactMe(true)}
              className="primary-cta-button"
            >
              Contact Me to Work Together
            </button>

            <div className="secondary-cta-group">
              <button onClick={Resume} className="icon-button" aria-label="Resume">
                <img src={resumeIcon} alt="Resume" />
              </button>
              <button onClick={Linkedin} className="icon-button" aria-label="LinkedIn">
                <img src={linkedinLight} alt="LinkedIn" />
              </button>
              <button onClick={Github} className="icon-button" aria-label="GitHub">
                <img src={githubLight} alt="GitHub" />
              </button>
            </div>
          </div>
        </div>

        <div className="hero-image-container fade-in-up delay-1">
          <div className="hero-image-wrapper">
            <img className="hero-image" src={seanPhoto} alt="Sean Brill" />
            <div className="hero-image-glow"></div>
          </div>
        </div>
      </div>

      <ContactMe
        initialLoad={props.initialLoad}
        show={showContactMe}
        onHide={() => setShowContactMe(false)}
      />
    </section>
  );
}

export default Header;

